import { defineStore } from "pinia";
import { ref, computed } from "vue";

export interface BanInfo {
  reason: string;
  started_at: string | null;
  ended_at: string | null;
  remaining_hours: number | null;
  remaining_text: string | null;
  is_permanent: boolean;
}

export const useBanStore = defineStore("ban", () => {
  const banned = ref(false);
  const message = ref("");
  const ban = ref<BanInfo | null>(null);

  const isBanned = computed(() => banned.value && ban.value !== null);

  const setBan = (data: {
    message?: string;
    banned: boolean;
    ban: BanInfo;
  }) => {
    banned.value = data.banned;
    message.value = data.message ?? "Аккаунт заблокирован";
    ban.value = data.ban ?? null;
  };

  const clearBan = () => {
    banned.value = false;
    message.value = "";
    ban.value = null;
  };

  const hasBan = (): boolean => banned.value && ban.value !== null;

  return {
    banned,
    message,
    ban,
    isBanned,
    setBan,
    clearBan,
    hasBan,
  };
});
